import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: false
})
export class LoadingComponent {

  @Input() diameter: number = 64;
  @Input() isCircle: boolean = true;
  @Input() isInline: boolean = false;
  @Input() failTitle: string = 'LoadingSpinner.Title';
  @Input() retryText: string = 'LoadingSpinner.Retry';
  @Input() hasLoaded: boolean = false;
  @Input() hasFailed: boolean = false;
  @Input() hideRetry: boolean = false;
  @Input() alignCenter: boolean = false;
  @Input() spinnerCss: string = '';
  @Output() retryClicked: EventEmitter<boolean> = new EventEmitter();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) { }

  onRetry() {
    this.retryClicked.emit(true);
  }

}
